import type {GlassBsdfNode} from "#material/cycles/types"
import type {Distribution} from "#material/nodes/shader/bsdf-glass/types"
import {Three as THREE} from "#material/three/exports"

export const getDefaultMaterial = () => new THREE.MeshPhysicalNodeMaterial()

export const cyclesDistribution = (distribution?: Distribution): GlassBsdfNode["parameters"]["distribution"] => {
    if (!distribution) {
        return undefined
    }
    switch (distribution) {
        case "BECKMANN":
            return "beckmann"
        case "GGX":
            return "ggx"
        case "MULTI_GGX":
            return "multi_ggx"
    }
}
